var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scroll-pane",
    [
      _c("action-header", { attrs: { slot: "header" }, slot: "header" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t("EventsHistory.filter.tooltip"),
                expression: "$t('EventsHistory.filter.tooltip')"
              }
            ],
            staticClass: "search"
          },
          [
            _c("VueIcon", { attrs: { icon: "search" } }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.filter,
                  expression: "filter",
                  modifiers: { trim: true }
                }
              ],
              ref: "filterEvents",
              attrs: { placeholder: "Filter events" },
              domProps: { value: _vm.filter },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.filter = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ],
          1
        ),
        _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t("EventsHistory.clear.tooltip"),
                expression: "$t('EventsHistory.clear.tooltip')"
              }
            ],
            staticClass: "button reset",
            class: { disabled: !_vm.events.length },
            on: { click: _vm.reset }
          },
          [
            _c("VueIcon", {
              staticClass: "small",
              attrs: { icon: "do_not_disturb" }
            }),
            _c("span", [_vm._v("Clear")])
          ],
          1
        ),
        _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t(
                  "EventsHistory." +
                    (_vm.enabled ? "stopRecording" : "startRecording") +
                    ".tooltip"
                ),
                expression:
                  "$t(`EventsHistory.${enabled ? 'stopRecording' : 'startRecording'}.tooltip`)"
              }
            ],
            staticClass: "button toggle-recording",
            on: { click: _vm.toggleRecording }
          },
          [
            _c("VueIcon", {
              staticClass: "small",
              class: { enabled: _vm.enabled },
              attrs: { icon: "lens" }
            }),
            _c("span", [_vm._v(_vm._s(_vm.enabled ? "Recording" : "Paused"))])
          ],
          1
        )
      ]),
      _c(
        "RecycleScroller",
        {
          staticClass: "history",
          class: {
            "high-density": _vm.highDensity
          },
          attrs: {
            slot: "scroll",
            items: _vm.filteredEvents,
            "item-size": _vm.highDensity ? 22 : 34
          },
          slot: "scroll",
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var event = ref.item
                var index = ref.index
                var active = ref.active
                return [
                  _c(
                    "div",
                    {
                      staticClass: "entry list-item",
                      class: { active: _vm.inspectedIndex === index },
                      attrs: { "data-active": active },
                      on: {
                        click: function($event) {
                          _vm.inspect(_vm.filteredEvents.indexOf(event))
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "event-name" }, [
                        _vm._v(_vm._s(event.eventName))
                      ]),
                      _c("span", { staticClass: "event-type" }, [
                        _vm._v(_vm._s(event.type))
                      ]),
                      _c("span", { staticClass: "event-source" }, [
                        _vm._v("\n          by\n          "),
                        _c("span", [_vm._v("<")]),
                        _c("span", { staticClass: "component-name" }, [
                          _vm._v(
                            _vm._s(_vm.displayComponentName(event.instanceName))
                          )
                        ]),
                        _c("span", [_vm._v(">")])
                      ]),
                      _c("span", { staticClass: "time" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatTime")(
                              event.timestamp,
                              _vm.$shared.timeFormat
                            )
                          )
                        )
                      ])
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm.filteredEvents.length === 0
            ? _c(
                "div",
                {
                  staticClass: "no-events",
                  attrs: { slot: "after-container" },
                  slot: "after-container"
                },
                [
                  _vm._v("\n      No events found"),
                  !_vm.enabled
                    ? _c("span", [_c("br"), _vm._v("(Recording is paused)")])
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }